export default __webpack_public_path__ + "static/media/previous.93101be8.svg";